var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFriction = function SvgFriction(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 118.25,
    y1: 63.414249,
    x2: 118.25,
    y2: 88.926689,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 72.5625,
    y1: 20.87113,
    x2: 72.5625,
    y2: 158.79631,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 56.4375,
    y1: 20.87113,
    x2: 56.4375,
    y2: 158.79631,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 45.6875,
    y1: 20.87113,
    x2: 45.6875,
    y2: 158.79631,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 69.875,
    y1: 20.87113,
    x2: 69.875,
    y2: 158.79631,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 80.625,
    y1: 20.87113,
    x2: 80.625,
    y2: 158.79631,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 91.375,
    y1: 20.87113,
    x2: 91.375,
    y2: 158.79631,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 20.87113,
    x2: 86,
    y2: 158.79631,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 52.40625,
    y1: 20.87113,
    x2: 52.40625,
    y2: 158.79631,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9350659"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 37.5 23.4375 C 37.5 25.164062 36.101562 26.5625 34.375 26.5625 C 32.648438 26.5625 31.25 25.164062 31.25 23.4375 C 31.25 21.710938 32.648438 20.3125 34.375 20.3125 C 36.101562 20.3125 37.5 21.710938 37.5 23.4375 Z M 37.5 23.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 9.375 10.9375 L 32.8125 10.9375 L 32.8125 12.5 L 9.375 12.5 Z M 9.375 10.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 23.4375 29.6875 L 23.4375 17.1875 C 23.4375 16.328125 22.734375 15.625 21.875 15.625 L 10.9375 15.625 C 10.078125 15.625 9.375 16.328125 9.375 17.1875 L 9.375 29.6875 C 9.375 30.546875 10.078125 31.25 10.9375 31.25 L 21.875 31.25 C 22.734375 31.25 23.4375 30.546875 23.4375 29.6875 Z M 15.625 29.6875 L 10.9375 29.6875 L 10.9375 26.5625 L 15.625 26.5625 Z M 15.625 25 L 10.9375 25 L 10.9375 21.875 L 15.625 21.875 Z M 15.625 20.3125 L 10.9375 20.3125 L 10.9375 17.1875 L 15.625 17.1875 Z M 21.875 29.6875 L 17.1875 29.6875 L 17.1875 26.5625 L 21.875 26.5625 Z M 21.875 25 L 17.1875 25 L 17.1875 21.875 L 21.875 21.875 Z M 21.875 20.3125 L 17.1875 20.3125 L 17.1875 17.1875 L 21.875 17.1875 Z M 21.875 20.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 9.375 36.71875 L 17.1875 36.71875 L 17.1875 38.28125 L 9.375 38.28125 Z M 9.375 36.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 19.53125 36.71875 L 21.09375 36.71875 L 21.09375 38.28125 L 19.53125 38.28125 Z M 19.53125 36.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 22.65625 36.71875 L 24.21875 36.71875 L 24.21875 38.28125 L 22.65625 38.28125 Z M 22.65625 36.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 25.78125 36.71875 L 27.34375 36.71875 L 27.34375 38.28125 L 25.78125 38.28125 Z M 25.78125 36.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 41.09375 21.484375 C 40.546875 19.609375 39.21875 18.046875 37.5 17.1875 L 37.5 7.03125 C 37.5 5.703125 36.484375 4.6875 35.15625 4.6875 L 7.03125 4.6875 C 5.703125 4.6875 4.6875 5.703125 4.6875 7.03125 L 4.6875 42.96875 C 4.6875 44.296875 5.703125 45.3125 7.03125 45.3125 L 35.15625 45.3125 C 36.484375 45.3125 37.5 44.296875 37.5 42.96875 L 37.5 33.359375 C 37.96875 33.515625 38.515625 33.59375 39.0625 33.59375 C 42.5 33.59375 45.3125 30.78125 45.3125 27.34375 C 45.3125 24.6875 43.59375 22.34375 41.09375 21.484375 Z M 39.84375 23.4375 C 39.84375 26.484375 37.421875 28.90625 34.375 28.90625 C 31.328125 28.90625 28.90625 26.484375 28.90625 23.4375 C 28.90625 20.390625 31.328125 17.96875 34.375 17.96875 C 37.421875 17.96875 39.84375 20.390625 39.84375 23.4375 Z M 35.9375 42.96875 C 35.9375 43.4375 35.625 43.75 35.15625 43.75 L 7.03125 43.75 C 6.5625 43.75 6.25 43.4375 6.25 42.96875 L 6.25 42.03125 C 6.484375 42.109375 6.71875 42.1875 7.03125 42.1875 L 35.15625 42.1875 C 35.46875 42.1875 35.703125 42.109375 35.9375 42.03125 Z M 35.9375 39.0625 L 35.9375 39.84375 C 35.9375 40.3125 35.625 40.625 35.15625 40.625 L 7.03125 40.625 C 6.5625 40.625 6.25 40.3125 6.25 39.84375 L 6.25 7.03125 C 6.25 6.5625 6.5625 6.25 7.03125 6.25 L 35.15625 6.25 C 35.625 6.25 35.9375 6.5625 35.9375 7.03125 L 35.9375 16.5625 C 35.46875 16.484375 34.921875 16.40625 34.375 16.40625 C 30.46875 16.40625 27.34375 19.53125 27.34375 23.4375 C 27.34375 27.03125 30.078125 30.078125 33.671875 30.46875 C 34.21875 31.484375 35 32.265625 35.9375 32.8125 Z M 39.0625 32.03125 C 37.65625 32.03125 36.40625 31.40625 35.46875 30.390625 C 38.828125 29.84375 41.40625 26.953125 41.40625 23.4375 C 41.40625 23.359375 41.40625 23.359375 41.40625 23.28125 C 42.8125 24.140625 43.75 25.625 43.75 27.34375 C 43.75 29.921875 41.640625 32.03125 39.0625 32.03125 Z M 39.0625 32.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear8)"
    },
    d: "M 9.375 33.59375 L 21.09375 33.59375 L 21.09375 35.15625 L 9.375 35.15625 Z M 9.375 33.59375 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFriction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/friction.f6cb4533.svg";
export { ForwardRef as ReactComponent };